import { useTheme } from 'next-themes';
import { useAuth } from '@/hooks/useAuth';
import logoBlack from '@/assets/autelion-logo-black.png';
import logoWhite from '@/assets/autelion-logo-white.png';

interface AutelionLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  forceDefault?: boolean;
}

const sizeClasses = {
  sm: 'h-6',
  md: 'h-8',
  lg: 'h-10',
  xl: 'h-12',
};

export function AutelionLogo({ size = 'md', className = '', forceDefault = false }: AutelionLogoProps) {
  const { theme, systemTheme } = useTheme();
  const { organization } = useAuth();
  
  // Determine if we should show dark mode logo
  const isDark = theme === 'dark' || (theme === 'system' && systemTheme === 'dark');
  const defaultLogoSrc = isDark ? logoWhite : logoBlack;
  
  // Use custom logo if available and not forcing default, otherwise use default Autelion logo
  const logoSrc = !forceDefault && organization?.logo_url ? organization.logo_url : defaultLogoSrc;
  const logoLink = !forceDefault && organization?.logo_link ? organization.logo_link : 'https://www.autelion.com';
  const altText = !forceDefault && organization?.name ? `${organization.name} Logo` : 'Autelion AB';
  
  return (
    <a 
      href={logoLink} 
      target="_blank" 
      rel="noopener noreferrer"
      className="flex-shrink-0"
    >
      <img 
        src={logoSrc} 
        alt={altText} 
        className={`${sizeClasses[size]} w-auto ${className}`}
      />
    </a>
  );
}
